//----------------------------------------
// modals.js
// Author: @codymarcoux (Studio123)
//----------------------------------------
if(jQuery('.modal').length > 0){
  // Move all modals to body
  $('.modal').appendTo('body');

  $('.open-modal').on('click', function(event){
    event.preventDefault();

    var modalID = $(this).data('modal');
    var modal = $(`.modal[data-modal=${modalID}]`);

    modal.addClass('active');
    $('body').addClass('is-locked');

    history.pushState({}, document.title, window.location.pathname + window.location.search);
  });

  $('body').on('click', '.modal .close-wrapper a, .modal .overlay', function(e) {
    if($(this).hasClass('close')){ e.preventDefault() }
    if($('.modal.active').find('.flowchart-overview').hasClass('is-active')){
      closeFlowchart();
    }
    $('.modal').removeClass('active');
    $('body').removeClass('is-locked');
  });
}